<template>
  <div class="auth-description">
    <h2 class="auth-title">
      {{ $t('Restore access') }}
    </h2>
    <div>
      <span class="text text-grey">
        {{ $t('Request the reset link or go') }}
      </span>
      <router-link :to="{ name: 'login' }" class="text link">
        {{ $t('back to login') }}
      </router-link>
    </div>
    <Form
      class="auth login-form"
      :error="error"
      :error-text="error"
      :success="
        isDone && $t('We sent an email with a link to password recovery, if it is registered')
      "
      @submit="submit"
    >
      <FormInput
        id="email-input"
        v-model="email"
        type="email"
        placeholder="mail@example.com"
        :label-text="$t('Email')"
      />

      <button
        v-if="!isDone"
        :disabled="isLoading"
        type="submit"
        class="btn-primary w-button w-full"
      >
        <Spinner v-if="isLoading" size="20" />
        <span v-else>
          {{ $t('Send link') }}
        </span>
      </button>
    </Form>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import required from 'vuelidate/src/validators/required';
  import email from 'vuelidate/src/validators/email';
  import Form from '@/components/common/Form';
  import FormInput from '@/components/ui/FormInput';
  import Spinner from 'vue-simple-spinner';
  import request from '../../utils/api/request';

  export default {
    name: 'Forgot',
    components: { FormInput, Form, Spinner },
    mixins: [validationMixin],
    data() {
      return {
        email: '',
        isLoading: false,
        isDone: false,
        error: null,
      };
    },
    validations: {
      email: { required, email },
    },
    methods: {
      async submit() {
        this.isLoading = true;
        this.error = null;

        this.$v.$touch();
        if (!this.$v.$invalid) {
          try {
            await request.post('/reset_password/', { email: this.email });
            this.isDone = true;
          } catch (e) {
            console.error(e); // eslint-disable-line
            this.error = e.message || e;
          }
        }

        this.isLoading = false;
      },
    },
  };
</script>
